(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .controller('LicenceItemController', LicenceItemControllerFn);

    /* controller for licence item directive */
    LicenceItemControllerFn.$inject = ['$state'];

    function LicenceItemControllerFn($state) {
        var vm = this;

        // edit licence
        vm.edit = function () {
            $state.go('Home.Administration.LicenceDetail', { 'licenceId': vm.licence.id });
        };
    }
})();
